import { objectToQueryString } from 'site-modules/shared/utils/string';
import {
  DEFAULT_PAGE_SIZE,
  DEFAULT_SORTING,
  DEFAULT_PAGE_NUM,
  NO_STYLE_ID,
  DEFAULT_RATING,
} from 'client/data/models/consumer-reviews';

export function buildConsumerReviewsUrl(reviewsFilter, vehicleFilter) {
  const { pagenum, pagesize, sorting, aspect, rating, polarity } = reviewsFilter;
  const { make, model, year, submodel, styleId } = vehicleFilter;
  const queryString = objectToQueryString({
    pagenum: pagenum === DEFAULT_PAGE_NUM ? undefined : pagenum,
    pagesize: pagesize === DEFAULT_PAGE_SIZE ? undefined : pagesize,
    sorting: sorting === DEFAULT_SORTING ? undefined : sorting,
    aspectname: aspect && aspect.displayName ? aspect.displayName : undefined,
    aspecttopic: aspect && aspect.topic ? aspect.topic : undefined,
    polarity,
    rating: rating === DEFAULT_RATING ? undefined : rating,
  });

  const styleIdParam = styleId && parseInt(styleId, 10) !== NO_STYLE_ID ? `st-${styleId}/` : '';
  const submodelSlug = submodel && !styleId ? `${submodel}/` : '';
  const queryParam = queryString ? `?${queryString}` : '';

  return `/${make}/${model}/${year}/${submodelSlug}${styleIdParam}consumer-reviews/${queryParam}`;
}

export function buildIndividualReviewUrl({ make, model, year, id }) {
  return `/${make}/${model}/${year}/consumer-reviews/review-${id}/`;
}

export function buildUpdateReviewUrl({ make, model, year, id }) {
  return `/${make}/${model}/${year}/update-consumer-review/review-${id}/`;
}
